var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3535 1.35403L6.35354 6.35403C6.3071 6.40052 6.25196 6.4374 6.19126 6.46256C6.13056 6.48772 6.0655 6.50067 5.99979 6.50067C5.93408 6.50067 5.86902 6.48772 5.80832 6.46256C5.74762 6.4374 5.69248 6.40052 5.64604 6.35403L0.64604 1.35403C0.552219 1.26021 0.499512 1.13296 0.499512 1.00028C0.499512 0.867596 0.552219 0.740348 0.64604 0.646528C0.73986 0.552707 0.867108 0.5 0.99979 0.5C1.13247 0.5 1.25972 0.552707 1.35354 0.646528L5.99979 5.2934L10.646 0.646528C10.6925 0.600073 10.7476 0.563222 10.8083 0.538081C10.869 0.51294 10.9341 0.5 10.9998 0.5C11.0655 0.5 11.1305 0.51294 11.1912 0.538081C11.2519 0.563222 11.3071 0.600073 11.3535 0.646528C11.4 0.692983 11.4368 0.748133 11.462 0.80883C11.4871 0.869526 11.5001 0.934581 11.5001 1.00028C11.5001 1.06598 11.4871 1.13103 11.462 1.19173C11.4368 1.25242 11.4 1.30757 11.3535 1.35403Z",
    fill: "#748181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.11105c66879c1ce33829d0ee03473f00.svg";
export { ForwardRef as ReactComponent };